<template>
  <div class="d-flex">
    <ModalConfirm 
      modalId="modalDeleteVoucher" 
      :text="`Are you sure to remove this voucher?`"
      @onClick="removeVoucher()"
      :center="true"
    />
    <div class="col-md-6">
      <div class="card">
        <div
          class="d-flex justify-content-between p-3 rounded-top"
          style="background-color: #f3f2f8"
        >
          <div
            class="text-start"
            style="color: #8d94a6; font-weight: bold; font-size: 10px"
          >
            VOUCHER NAME
          </div>
          <div
            class=""
            style="color: #8d94a6; font-weight: bold; font-size: 10px"
          >
            ACTION
          </div>
        </div>

        <div class="d-flex align-items-center p-3 border-bottom" style="width: 100%">
          <input
            v-model="voucher"
            id="input-1"
            class="border-0 w-100"
            style="outline:none"
            placeholder="Type Voucher"
          />
          <button
            style="white-space: nowrap"
            class="btn btn-danger text-white"
            @click="addVoucher()"
            :disabled="!voucher"
          >
            Add Voucher
          </button>
        </div>
        <div v-if="loading">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else v-for="(data, k) in voucherlist" :key="k">
          <div class="d-flex p-3" :class="k !== voucherlist.length - 1 ? 'border-bottom' : ''">
            <div class="me-auto">
              <span>
                {{data.voucher_code}}
              </span>
            </div>
            <div
              style="text-decoration: none; cursor: pointer"
              @click="selectedIndex = k"
              data-bs-toggle="modal" 
              data-bs-target="#modalDeleteVoucher"
            >
              <font-awesome-icon icon="fa-solid fa-trash" />
            </div>
          </div>

          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalConfirm from "@/components/ModalConfirm.vue"
export default {
  components:{
    ModalConfirm
  },
  data() {
    return {
      voucher: "",
      seller_data: "",
      loading: false,
      voucherlist: [],
      cancelseller: [],
      selectedIndex: 0,
    };
  },
  mounted() {
    this.$store
      .dispatch("voucher/getAllVoucher")
      .then((response) => {
        console.log(response);
        this.voucherlist = response.data.data.vouchers;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    refreshdata() {
      console.log("masuk");
      this.$store
        .dispatch("voucher/getAllVoucher")
        .then((response) => {
          console.log(response);
          this.voucherlist = response.data.data.vouchers;
        })
        .catch(() => {
          // console.log(error);
        });
    },
    updateVoucher(add) {
      const payload = {
        voucher: add
      }
      this.$store
        .dispatch("voucher/putVoucher", payload)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      // this.refreshdata();
    },
    deleteVoucher(data) {
      const voucher = data?.voucher_code || data
      this.$store
        .dispatch("voucher/deleteVoucher", voucher)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
      // this.refreshdata();
    },
    addVoucher() {
      var data = {
        voucher_code: this.voucher
      }
      this.voucherlist.push(data);
      this.updateVoucher(this.voucher);
      this.voucher = "";
    },
    removeVoucher() {
      this.deleteVoucher(this.voucherlist[this.selectedIndex]);
      this.voucherlist.splice(this.selectedIndex, 1);
    },
  },
};
</script>

<style></style>
